import './Settings.css';
import React, { useState, useEffect } from "react";
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye'
import {
  GetConfig,
  PutAppointmentsConfig,
  PutAccountDetailsConfig,
  PutCustomerisationCommunicationsConfig,
  SendTestConfirmationEmail,
  PutNotificationsConfig,
  VerificationCode,
  UpdateEmail,
  UpdatePassword,
  ConnectStripeAccount,
  GetLoginLink,
  GetPaymentServiceDetails,
  UpdateAcceptOnlinePaymentsOption,
  DisconnectStripeAccount
} from './Requests';
import {
  notifyError,
  notifySuccess
} from '../../Response/ResposeHandler'
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {PulseLoader } from "react-spinners";
import { getConfig } from '@testing-library/react';
import Payments from '../../OnlineBooking/Payments';

const intervalOptions = [
  { value: 1, label: '10 mins' },
  { value: 2, label: '15 mins' },
  { value: 3, label: '20 mins' }
]

const timeZoneOptions = []
Intl.supportedValuesOf('timeZone').map((timeZone, index) => {
  // if (timeZone.split("/")[0] === "Europe")
  if (true)

  {
    timeZoneOptions.push({value: timeZone, label: timeZone.split("/")[1]})
  }
})

const Settings = () => {
  const [activeTab, setActiveTab] = useState("Account");
  const [activeSubTab, setActiveSubTab] = useState("Appointments");
  const [activeSubAccountsTab, setActiveSubAccountsTab] = useState("Details");
  const [isLoading, setIsLoading] = useState(true)
  const [config, setConfig] = useState()
  const [paymentServiceDetails, setPaymentServiceDetails] = useState()
  const [interval, setInterval] = useState()
  const [shopName, setShopName] = useState()
  // const [addressNumberName, setAddressNumberName] = useState()
  // const [addressFirstLine, setAddressFirstLine] = useState()
  // const [addressSecondLine, setAddressSecondLine] = useState()
  // const [addressCity, setAddressCity] = useState()
  // const [addressCounty, setAddressCounty] = useState()
  // const [addressPostcode, setAddressPostcode] = useState()
  const [phoneNumber, setPhoneNumber] = useState()
  const [confirmationMessage, setConfirmationMessage] = useState()
  const [notesMessage, setNotesMessage] = useState()
  const [cancellationPolicyMessage, setCancellationPolicyMessage] = useState()
  const [appointmentCancelledMessage, setAppointmentCancelledMessage] = useState()
  const [appointmentChangedMessage, setAppointmentChangedMessage] = useState()
  const [notificationLogon, setNotificationLogon] = useState()
  const [notificationBookingComplete, setNotificationBookingComplete] = useState()
  const [notificationBookingCancelled, setNotificationBookingCancelled] = useState()
  const [currentEmailAddress, setCurrentEmailAddress] = useState()
  const [newEmailAddress, setNewEmailAddress] = useState()
  const [currentPassword, setCurrentPassword] = useState()
  const [newPassword, setNewPassword] = useState()
  const [newPasswordTwo, setNewPasswordTwo] = useState()
  const [code, setCode] = useState(['', '', '', '', '']);
  const [showVerficationPopup, setShowVerficationPopup] = useState(false);
  const [verficationType, setVerficationType] = useState("");
  const [codeFull, setCodeFull] = useState(false)
  const [codeInvalid, setCodeInvalid] = useState(false)
  const [updateEmailButton, setUpdateEmailButton] = useState(false)
  const [updatePasswordButton, setUpdatePasswordButton] = useState(false)
  const [passwordError, setPasswordError] = useState('')
  const [currentPasswordIcon, setCurrentPasswordIcon] = useState(eyeOff)
  const [newPasswordIcon, setNewPasswordIcon] = useState(eyeOff)
  const [newPasswordTwoIcon, setNewPasswordTwoIcon] = useState(eyeOff)
  const [currentPasswordType, setCurrentPasswordType] = useState('password');
  const [newPasswordType, setNewPasswordType] = useState('password');
  const [newPasswordTwoType, setNewPasswordTwoType] = useState('password');
  const [shopNameEror, setShopNameError] = useState("")
  const [phoneNumberError, setPhoneNumberError] = useState("")
  // const [addressNumberNameError, setAddressNumberNameError] = useState("")
  // const [addressFirstLineError, setAddressFirstLineError] = useState("")
  // const [addressSecondLineError, setAddressSecondLineError] = useState("")
  // const [addressCityError, setAddressCityError] = useState("")
  // const [addressCountyError, setAddressCountyError] = useState("")
  // const [addressPostcodeError, setAddressPostcodeError] = useState("")
  const queryParameters = new URLSearchParams(window.location.search)
  const optionFromUrlParam = queryParameters.get("setting-option")
  const [settingsOption, SetSettingsOption] = useState(optionFromUrlParam)
  const [status , setStatus] = useState("null")
  const [selectedTimeZone, setSelectedTimeZone] = useState()

  useEffect(() => {
    GetConfigWrapper()
  }, []);

  function GetConfigWrapper() {
    setIsLoading(true)
    GetConfig().then((res) => {
      setConfig(res.data)
      setShopName(res.data.shopName)
      setSelectedTimeZone(timeZoneOptions.filter(x => x.value === res.data.timeZone)[0])
      // setAddressNumberName(res.data.addressNumberName)
      // setAddressFirstLine(res.data.addressFirstLine)
      // setAddressSecondLine(res.data.addressSecondLine)
      // setAddressCity(res.data.addressCity)
      // setAddressCounty(res.data.addressCounty)
      // setAddressPostcode(res.data.addressPostcode)
      setPhoneNumber(res.data.phoneNumber)
      setConfirmationMessage(res.data.appointmentConfirmationMessageToCustomer)
      setNotesMessage(res.data.appointmentReminderNotesToCustomer)
      setCancellationPolicyMessage(res.data.appointmentCancellationPolicyToCustomer)
      setAppointmentCancelledMessage(res.data.appointmentCancellationMessageToCustomer)
      setAppointmentChangedMessage(res.data.appointmentChangedMessageToCustomer)
      setNotificationLogon(res.data.notificationLogon)
      setNotificationBookingComplete(res.data.notificationBookingComplete)
      setNotificationBookingCancelled(res.data.notificationBookingCancelled)
      setInterval(intervalOptions.filter(x => x.value === res.data.durationBlock)[0])
      setCodeFull(false)
      setCodeInvalid(false)
      if (optionFromUrlParam !== null)
      {
        setActiveTab(settingsOption.split("-")[0])
        setActiveSubAccountsTab(settingsOption.split("-")[1])
      }
      if (!res.data.payoutsEnabled)
      {
        setStatus("no payouts")
      }
      if (!res.data.chargesEnabled)
      {
        setStatus("no charges")
      }
      if (res.data.payoutsEnabled && res.data.chargesEnabled)
      {
        setStatus("Connected")
      }

    }).catch((error) => {
      notifyError("Unable to retrieve config settings, please try again")
    }).finally(() => {
      GetPaymentServiceDetailsWrapper()
    })
  }

  function GetPaymentServiceDetailsWrapper()
  {
    GetPaymentServiceDetails().then((res) => {
      console.log(res.data)
      if (res.status === 200)
      {
        setPaymentServiceDetails(res.data)
      }
      setIsLoading(false)
    })
  }
  function onCickAppointmentSettingsSave(serviceId, name, description, duration, price) {
    PutAppointmentsConfig(interval.value).then((res) => {
      notifySuccess("saved")
    }).catch((error) => {
      notifyError("There was an issue saving your settings. Please try again or contact administrator")
    }).finally((f) => {
      GetConfigWrapper()
    })
  }

  function handlePasswordIconToggle(passwordBox)
  {
    if (passwordBox === "currentPassword")
    {
      if (currentPasswordType === "password")
      {
        setCurrentPasswordType('text')
        setCurrentPasswordIcon(eye)
      }
      else
      {
        setCurrentPasswordType('password')
        setCurrentPasswordIcon(eyeOff)
      }
    }

  if (passwordBox === "newPassword")
    {
      if (newPasswordType === "password")
        {
          setNewPasswordType('text')
          setNewPasswordIcon(eye)
        }
        else
        {
          setNewPasswordType('password')
          setNewPasswordIcon(eyeOff)
        }
    }

  if (passwordBox === "newPasswordTwo")
    {
      if (newPasswordTwoType === "password")
        {
          setNewPasswordTwoType('text')
          setNewPasswordTwoIcon(eye)
        }
        else
        {
          setNewPasswordTwoType('password')
          setNewPasswordTwoIcon(eyeOff)
        }
    }
  }

  function onClickSendTestConfirmationEmail() {
    SendTestConfirmationEmail().then((res) => {
      if (res.status === 200)
      {
        notifySuccess("Email sent to address associated with your account")
      }
    }).catch((error) => {
      notifyError("There was an issue saving your settings. Please try again or contact administrator")
    }).finally((f) => {
      
    })
  }

  function onCickAccountDetailsSettingsSave() {
    setShopNameError("")
    // setAddressNumberNameError("")
    // setAddressFirstLineError("")
    // setAddressSecondLineError("")
    // setAddressCityError("")
    // setAddressCountyError("")
    // setAddressPostcodeError("")
    setPhoneNumberError("")
    let error = false
    if (shopName === "" || shopName === undefined || shopName === null)
    {
      setShopNameError("Please enter a shop name")
      error = true
    }
    // if (addressNumberName === "" || addressNumberName === undefined || addressNumberName === null)
    // {
    //   setAddressNumberNameError("Please enter a shop name")
    //   error = true
    // }
    // if (addressFirstLine === "" || addressFirstLine === undefined || addressFirstLine === null)
    // {
    //   setAddressFirstLineError("Please enter a shop name")
    //   error = true
    // }
    // if (addressSecondLine === "" || addressSecondLine === undefined || addressSecondLine === null)
    // {
    //   setAddressSecondLineError("Please enter a shop name")
    //   error = true
    // }
    // if (addressCity === "" || addressCity === undefined || addressCity === null)
    // {
    //   setAddressCityError("Please enter a shop name")
    //   error = true
    // }
    // if (addressCounty === "" || addressCounty === undefined || addressCounty === null)
    // {
    //   setAddressCountyError("Please enter a shop name")
    //   error = true
    // }
    // if (addressPostcode === "" || addressPostcode === undefined || addressPostcode === null)
    // {
    //   setAddressPostcodeError("Please enter a shop name")
    //   error = true
    // }

    // if (phoneNumber === "" || phoneNumber === undefined || phoneNumber === null)
    // {
    //   setPhoneNumberError("Please enter a shop name")
    //   error = true
    // }

    if (error === false) {
      PutAccountDetailsConfig(
        shopName,
        // addressNumberName,
        // addressFirstLine,
        // addressSecondLine,
        // addressCity,
        // addressCounty,
        // addressPostcode,
        phoneNumber,
        selectedTimeZone.value).then((res) => {
          if (res.status === 200)
          {
            notifySuccess("saved")
          }
      }).catch((error) => {
        notifyError("There was an issue saving your settings. Please try again or contact administrator")
      }).finally((f) => {
        
        GetConfigWrapper()
      })
    }
  }

  function onCickCustomerisationCommunicationsSettingsSave(e) {
    PutCustomerisationCommunicationsConfig(
      confirmationMessage,
      notesMessage,
      cancellationPolicyMessage,
      appointmentChangedMessage,
      appointmentCancelledMessage).then((res) => {
        if (res.status === 200)
          {
            notifySuccess("saved")
          }
    }).catch((error) => {
      notifyError("There was an issue saving your settings. Please try again or contact administrator")
    }).finally((f) => {
      
      GetConfigWrapper()
    })
  }
  function CurrentEmailAddressHandler(e) {
    setCurrentEmailAddress(e.target.value.toLowerCase())
    if (newEmailAddress === "" || newEmailAddress === undefined || newEmailAddress === null || e.target.value === "" || e.target.value === undefined || e.target.value === null)
    {
      setUpdateEmailButton(false)
    }
    else
    {
      setUpdateEmailButton(true)
    }
  }

  function NewEmailAddressHandler(e) {
    setNewEmailAddress(e.target.value)
    if (e.target.value === "" || e.target.value === undefined || e.target.value === null || currentEmailAddress === "" || currentEmailAddress === undefined || currentEmailAddress === null)
      {
        setUpdateEmailButton(false)
      }
      else
      {
        setUpdateEmailButton(true)
      }
  }

  function CurrentPasswordHandler(e) {
    setCurrentPassword(e.target.value)
    if (newPassword === "" || newPassword === undefined || newPassword === null || newPasswordTwo === "" || newPasswordTwo === undefined || newPasswordTwo === null || e.target.value === "" || e.target.value === undefined || e.target.value === null)
    {
      setUpdatePasswordButton(false)
    }
    else
    {
      setUpdatePasswordButton(true)
    }
  }

  function NewPasswordHandler(e) {
    setNewPassword(e.target.value)
    if (e.target.value === "" || e.target.value === undefined || e.target.value === null || newPasswordTwo === "" || newPasswordTwo === undefined || newPasswordTwo === null || currentPassword === "" || currentPassword === undefined || currentPassword === null)
      {
        setUpdatePasswordButton(false)
      }
      else
      {
        setUpdatePasswordButton(true)
      }
  }

  function NewPasswordTwoHandler(e) {
    setNewPasswordTwo(e.target.value)
    if (newPassword === "" || newPassword === undefined || newPassword === null || e.target.value === "" || e.target.value === undefined || e.target.value === null || currentPassword === "" || currentPassword === undefined || currentPassword === null)
      {
        setUpdatePasswordButton(false)
      }
      else
      {
        setUpdatePasswordButton(true)
      }
  }

  function updateEmailAddressClick(reason) {
    setVerficationType("email update")
    setCode(['', '', '', '', ''])
    if ((currentEmailAddress !== undefined && newEmailAddress !== undefined))
    {
      if (currentEmailAddress === config.shopEmail.toLowerCase())
        {
          if (currentEmailAddress !== newEmailAddress)
            {
              VerificationCode(reason, newEmailAddress).then((res) => {
                  if (res.status === 200)
                    {
                      notifySuccess("Code sent")
                      setShowVerficationPopup(true)
                    }
              }).catch((error) => {
                if (error.response.request.status === 409)
                  {
                    notifyError("This email address is already being used")
                    setShowVerficationPopup(false)
                    setVerficationType("")
                    setCodeFull(false)
                    setCodeInvalid(false)
                  }
                  else
                  {
                    notifyError("There was an issue sending the code. Please check the new email address and try again")
                  }
              }).finally((f) => {
                
              })
            }
            else
            {
              notifyError("The new email address is the same")
            }
        }
        else
        {
          notifyError("The current email address does not match the email address of this account")
        }
    }
  }

  function updateEmailAddressClick(reason) {
    setVerficationType("email update")
    setCode(['', '', '', '', ''])
    if ((currentEmailAddress !== undefined && newEmailAddress !== undefined))
    {
      if (currentEmailAddress === config.shopEmail.toLowerCase())
        {
          if (currentEmailAddress !== newEmailAddress)
            {
              VerificationCode(reason, newEmailAddress).then((res) => {
                  if (res.status === 200)
                    {
                      notifySuccess("Code sent")
                      setShowVerficationPopup(true)
                    }
              }).catch((error) => {
                if (error.response.request.status === 409)
                  {
                    notifyError("This email address is already being used")
                    setShowVerficationPopup(false)
                    setVerficationType("")
                    setCodeFull(false)
                    setCodeInvalid(false)
                  }
                  else
                  {
                    notifyError("There was an issue sending the code. Please check the new email address and try again")
                  }
              }).finally((f) => {
                
              })
            }
            else
            {
              notifyError("The new email address is the same")
            }
        }
        else
        {
          notifyError("The current email address does not match the email address of this account")
        }
    }
  }

  function updatePasswordClick(reason) {
    setVerficationType("password update")
    setCode(['', '', '', '', ''])
    if (newPassword !== newPasswordTwo)
    {
      setPasswordError('Passwords do not match')
    }
    else
    {
      if (newPassword.length < 8) {
        setPasswordError('Password needs to be atleast 8 characters')
      }
      else{
        if (currentPassword === newPassword)
        {
          setPasswordError('Please choose a password that is different to the current password')
        }
        else
        {
          setPasswordError('')
          VerificationCode(reason, currentPassword).then((res) => {
            if (res.status === 200)
              {
                notifySuccess("Code sent")
                setShowVerficationPopup(true)
              }
        }).catch((error) => {
          if (error.response.request.status === 404)
            {
              notifyError("Current password is incorrect, please try again or click forgot password")
              setShowVerficationPopup(false)
              setVerficationType("")
              setCodeFull(false)
              setCodeInvalid(false)
            }
            else
            {
              notifyError("There was an issue sending the code. Please check the new email address and try again")
            }
        }).finally((f) => { 
        })
        }
      }

    }

  }



  function ResendCode() {
    setCode(['', '', '', '', ''])
    setCodeFull(false)
    setCodeInvalid(false)
    VerificationCode(verficationType, verficationType === "email update" ? newEmailAddress : currentPassword).then((res) => {
      if (res.status === 200)
        {
          notifySuccess("Code sent")
        }
  }).catch((error) => {
    notifyError("There was an issue sending the code. Please try again or contact administrator")
  }).finally((f) => {
  })
  }

  function NotificationOptionHandler(e) {
    if (e.target.id === "logon")
      {
        setNotificationLogon(e.target.checked)
        PutNotificationsConfig(
          e.target.id,
          e.target.checked).then((res) => {
            if (res.status === 200)
              {
                notifySuccess("saved")
              }
        }).catch((error) => {
          notifyError("There was an issue saving your settings. Please try again or contact administrator")
        }).finally((f) => {
          
          // GetConfigWrapper()
        })
      }

    if (e.target.id === "completeBooking")
      {
        setNotificationBookingComplete(e.target.checked)
        PutNotificationsConfig(
          e.target.id,
          e.target.checked).then((res) => {
            if (res.status === 200)
              {
                notifySuccess("saved")
              }
        }).catch((error) => {
          notifyError("There was an issue saving your settings. Please try again or contact administrator")
        }).finally((f) => {
          
          // GetConfigWrapper()
        })
      }

    if (e.target.id === "cancelBooking")
      {
        setNotificationBookingCancelled(e.target.checked)
        PutNotificationsConfig(
          e.target.id,
          e.target.checked).then((res) => {
            if (res.status === 200)
              {
                notifySuccess("saved")
              }
        }).catch((error) => {
          notifyError("There was an issue saving your settings. Please try again or contact administrator")
        }).finally((f) => {
          // GetConfigWrapper()
        })
      }
}

function VerificationCancelClick(e) {
  setShowVerficationPopup(false)
  setVerficationType("")
  setCodeFull(false)
  setCodeInvalid(false)
}

function VerifyClick() {
  if (verficationType === "email update")
  {
    UpdateEmail(
      currentEmailAddress,
      newEmailAddress,
      code).then((res) => {
        if (res.status === 200)
          {
            notifySuccess("Email address updated")
            setShowVerficationPopup(false)
            setCodeFull(false)
            GetConfigWrapper()
            setUpdateEmailButton(false)
          }
    }).catch((error) => {
      if (error.response.request.status === 412)
      {
        setCodeInvalid(true)
      }
      else
      {
        notifyError("There was an issue updating your email address. Please try again or contact administrator")
        setShowVerficationPopup(false)
        setVerficationType("")
        setCodeFull(false)
        setCodeInvalid(false)
      }

    }).finally((f) => {
      
    })
  }

  if (verficationType === "password update")
  {
    UpdatePassword(
      currentPassword,
      newPassword,
      newPasswordTwo,
      code).then((res) => {
        if (res.status === 200)
          {
            notifySuccess("Password updated")
            setShowVerficationPopup(false)
            setCodeFull(false)
            GetConfigWrapper()
            setUpdatePasswordButton(false)
          }
    }).catch((error) => {
      if (error.response.request.status === 412)
      {
        setCodeInvalid(true)
      }
      else
      {
        notifyError("There was an issue updating your password. Please try again or contact administrator")
        setShowVerficationPopup(false)
        setVerficationType("")
        setCodeFull(false)
        setCodeInvalid(false)
      }

    }).finally((f) => {
      
    })
  }
}

function handleInputChange(index, value) {
  if (index !== 4)
  {
    simulateTab()
  }
  const newCode = [...code];
  newCode[index] = value.slice(0, 1); // Ensures only one character per slot
  setCode(newCode);
  if (newCode[0] !== '' && newCode[1] !== '' && newCode[2] !== '' && newCode[3] !== '' && newCode[4] !== '')
  {
    setCodeFull(true)
  }
  else {
    setCodeFull(false)
  }
}

function simulateTab() {
  const focusableElements = document.querySelectorAll(
    'input, [tabindex]:not([tabindex="-1"])'
  );
  const elements = Array.from(focusableElements).filter(el => !el.disabled && el.offsetParent !== null);
  const currentIndex = elements.indexOf(document.activeElement);
  const nextIndex = (currentIndex + 1) % elements.length;
  elements[nextIndex].focus();
}

  const renderAccountsSubPage = () => {
    switch (activeSubAccountsTab.toLowerCase()) {
      case "details":
        return (
          <main>
          <h1>Details</h1>
          <label htmlFor="shop-name">Shop Name</label>
          <input onChange={(e) => {setShopName(e.target.value)}} type="text" id="shop-name" placeholder="Shop Name" defaultValue={config.shopName}/>
          <p className='error-label'>{shopNameEror}</p>

          <label htmlFor="phone-number">Phone Number <span style={{fontSize:"0.8rem"}}>(use a mobile that you want support to be able to contact you on)</span></label>
          <input onChange={(e) => {setPhoneNumber(e.target.value)}} type="tel" id="phone-number" placeholder="Phone Number" defaultValue={config.phoneNumber}/>
          <p className='error-label'>{phoneNumberError}</p>

          <label htmlFor="phone-number">Time Zone</label>
          <div className=''>
            <Select
              placeholder="Start"
              closeMenuOnSelect={true}
              options={timeZoneOptions}
              defaultValue={selectedTimeZone}
              onChange={(e) => {setSelectedTimeZone({value:e.value ,label: e.label})}}
            />
          </div>
          {/* <h3 style={{marginTop:"2rem"}}>Address</h3>
          <label htmlFor="address-number-name">Number or Name</label>
          <input onChange={(e) => {setAddressNumberName(e.target.value)}} type="text" id="address-number-name" placeholder="Number / Name" defaultValue={config.addressNumberName}/>
          <p className='error-label'>{addressNumberNameError}</p>

          <label htmlFor="address-first-line">First Line</label>
          <input onChange={(e) => {setAddressFirstLine(e.target.value)}} type="text" id="address-first-line" placeholder="First Line" defaultValue={config.addressFirstLine}/>
          <p className='error-label'>{addressFirstLineError}</p>

          <label htmlFor="address-second-line">Second Line</label>
          <input onChange={(e) => {setAddressSecondLine(e.target.value)}} type="text" id="address-second-line" placeholder="Second Line" defaultValue={config.addressSecondLine}/>
          <p className='error-label'>{addressSecondLineError}</p>

          <label htmlFor="address-city">City</label>
          <input onChange={(e) => {setAddressCity(e.target.value)}} type="text" id="address-city" placeholder="City" defaultValue={config.addressCity}/>
          <p className='error-label'>{addressCityError}</p>

          <label htmlFor="address-county">County</label>
          <input onChange={(e) => {setAddressCounty(e.target.value)}} type="text" id="address-county" placeholder="County" defaultValue={config.addressCounty}/>
          <p className='error-label'>{addressCountyError}</p>

          <label htmlFor="address-postcode">Postcode</label>
          <input onChange={(e) => {setAddressPostcode(e.target.value)}} type="text" id="address-postcode" placeholder="Postcode" defaultValue={config.addressPostcode}/>
          <p className='error-label'>{addressPostcodeError}</p> */}

          <button onClick={() => {onCickAccountDetailsSettingsSave()}} className='save-button button'>Save</button>
        </main>
        );
      case "membership":
        return (
          <main>
          <h1>Membership</h1>
          <button className='save-button button'>Save</button>
        </main>
        );
      case "payments":
        return (
          <Payments getConfig={GetConfigWrapper} paymentServiceDetails={paymentServiceDetails} status={status} config={config}/>
//           <main>
//             {/* <h1>Payments</h1> */}
//             {config.stripeAccountId === null ?
//             <div>
//               <h1>Payments</h1>
//                 <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
//                   <button onClick={ConnectStripAccountButtonClick} className='connect-button mb-3'>
                    
//                     {!connectStripeAccountLoading ?
//                     "Connect Stripe Account":
//                     <PulseLoader 
//                       color={'#eee'}
//                       loading={connectStripeAccountLoading}
//                       size={10}
//                       aria-label="Loading Spinner"
//                       data-testid="loader"
//                     />
//                     }
//                     </button>
//                 </div>
//             </div>
//             :
//             !config.detailsSubmitted ?
//             <div>
//               <h1>Payments</h1>
//                 <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
//                   <button onClick={ConnectStripAccountButtonClick} className='finish-setup-button mb-3'>Finish Stripe Account Setup</button>
//                 </div>
//             </div>
//             :
//             <div>
                        

//     <div className="stripe-container">
//       <div className="header-stripe">
//         {/* <h2>Stripe Connect Settings</h2> */}
//           <div className={`status mb-3 ${status.toLowerCase().replace(" ", "-")}`}>
//           {status === "Connected" ? "Connected to stripe account" : status === "no payouts" ? "Stripe payouts are currently not setup, please finish stripe setup" : status === "no charges" ? <span>Stripe charges are currently not setup, please finish stripe setup</span>: "" }
//         </div>
//         <h1>Payments</h1>
//         <div className="stripe-toggle-row">
//           <label className='enable-payments-switch-label'>Accept Online Payments for services</label>
//           <label style={{marginLeft:"1rem", marginTop:"1.3rem"}} className="switch">
//           <input
//             type="checkbox"
//             defaultChecked={enabledOnlinePaymentsButton}
//             onChange={(e) => {updateAcceptPaymentsOption(e)}}
//           />
//           <span className="slider round"></span>
//           </label>
//         </div>
//       </div>
// <div className="stripe-info-section">
//   <div className="stripe-info-card">
//     <label>Available Funds</label>
//     <p style={{fontSize:"2rem"}}>£{Number(paymentServiceDetails.availableFunds/100).toFixed(2)}</p>
//   </div>
//   <div className="stripe-info-card">
//     <label>Pending Funds</label>
//     <p style={{fontSize:"2rem"}}>£{Number(paymentServiceDetails.pendingFunds/100).toFixed(2)}</p>
//   </div>
// </div>
//       <div>
//         <div className='divider'>

//         </div>
//         <h3 className="heading-three">Stripe Account</h3>
//         <div className="stripe-action-buttons">
//           <button onClick={ManageStripeAccountClicked} className="stripe-manage-button">
//             {!manageAccountButtonLoading ? 
//             "Manage Account" :
//             <PulseLoader 
//                 color={'#eee'}
//                 loading={manageAccountButtonLoading}
//                 size={8}
//                 aria-label="Loading Spinner"
//                 data-testid="loader"
//             />
//             }
//             {/* Manage Stripe Account */}

//           </button>
//           <button onClick={DisconnectAccountClicked} className="stripe-delete-button">
//             {disconnectAccountButtonLoading ?
//                         <PulseLoader 
//                 color={'#e63e3e'}
//                 loading={disconnectAccountButtonLoading}
//                 size={8}
//                 aria-label="Loading Spinner"
//                 data-testid="loader"
//             /> :
//             "Disconnect Account"
//             }
//           </button>
//         </div>
//       </div>
//         <div className='divider'>

//         </div>
//       <div className="help-section">
//         <h3>Need Help?</h3>
//         <ul>
//           <li><a href="https://stripe.com/docs/connect/express-dashboard" target="_blank" rel="noopener noreferrer">What is Stripe Connect?</a></li>
//           <li><a href="/support">Contact Support</a></li>
//         </ul>
//       </div>
//     </div>
//     </div>
//           }
//           </main>
        );
      default:
        return null;
    }
  };
 
  const renderAnalyticsSubPage = () => {
    switch (activeSubTab.toLowerCase()) {
      case "appointments":
        return (
          <main>
          <h1>Appointments</h1>
          <span className='label-title' htmlFor="measurement-id">Scheduling interval</span>
          <span className='label-description' htmlFor="measurement-id">Please choose an appointment interval which will govern how long an appointment can be.</span>
          <div className='interval-chooser'>
          <Select
            placeholder="Start"
            closeMenuOnSelect={true}
            options={intervalOptions}
            defaultValue={intervalOptions.filter(x => x.value === config.durationBlock)[0]}
            onChange={(e) => {setInterval({value:e.value ,label: e.label})}}
          />
          </div>
          <span style={{color:"red"}} className='label-description' htmlFor="measurement-id">Please note, when changing the scheduling interval, existing appointments and holidays may not reflect the exact same timing as before. The system will try to allocate appointments and holidays as best as possible, however we suggest you double check appointments and holidays after changing the scheduling interval.</span>
          <button onClick={onCickAppointmentSettingsSave} className='save-button button'>Save</button>
        </main>
        );
      case "communications":
        return (
          <main>
          <h1>Communications</h1>
          <p>These are template messages that will be sent to the customer to keep them updated on their appointment status.</p>

          <h3 style={{marginTop:"2rem"}}>Appointment Confirmation Message</h3>
          <p>Please use the following for keys for where appropiate</p>
          <li style={{fontSize:"0.9rem"}}><b>#staffName# </b> for where the name of the staff is to be used in the message</li>
          <li style={{fontSize:"0.9rem"}}><b>#date# </b> for where the date of the appointment is to be used in the message</li>
          <li style={{fontSize:"0.9rem"}}><b>#time# </b> for where the time of the appointment is to be used in the message</li>

          <label>Message</label>
          <textarea onChange={(e) => {setConfirmationMessage(e.target.value)}} maxLength={300} rows="4" type="textarea" placeholder="Appointment confirmation message" defaultValue={config.appointmentConfirmationMessageToCustomer}/>

          <label>Notes</label>
          <textarea onChange={(e) => {setNotesMessage(e.target.value)}} maxLength={300} rows="4" type="textarea" placeholder="Appointment Notes" defaultValue={config.appointmentReminderNotesToCustomer}/>

          <label>Cancellation Policy</label>
          <textarea onChange={(e) => {setCancellationPolicyMessage(e.target.value)}} maxLength={300} rows="4" type="textarea" placeholder="Cancellation policy message" defaultValue={config.appointmentCancellationPolicyToCustomer}/>
          <button onClick={onClickSendTestConfirmationEmail} className='send-email-button'>Send test confirmation email</button>
          <h3 style={{marginTop:"2rem"}}>Appointment Ammendments Messages</h3>
          <label>Appointment Cancellation Message</label>
          <textarea onChange={(e) => {setAppointmentCancelledMessage(e.target.value)}} maxLength={300} rows="4" type="textarea" placeholder="Appointment cancellation message" defaultValue={config.appointmentCancellationMessageToCustomer}/>

          <label>Appointment Change Message</label>
          <textarea onChange={(e) => {setAppointmentChangedMessage(e.target.value)}} maxLength={300} rows="4" type="textarea" placeholder="Appointment changed message" defaultValue={config.appointmentChangedMessageToCustomer}/>

          <button onClick={onCickCustomerisationCommunicationsSettingsSave} className='save-button button'>Save</button>
        </main>
        );
      case "notifications":
        return (
          <main>
            <h1>Notifications</h1>
            <p>These are notifictions that will be sent to your associated email address, which can help keep you updated on incoming bookings</p>
            <div className="toggle-container">
              <span className='label-title'>Email notification upon logging into the system</span>
              <div className="switch-wrapper">
                <input
                onChange={(e) => {NotificationOptionHandler(e)}}
                className="toggle-switch"
                type="checkbox"
                defaultChecked={false}
                checked={notificationLogon}
                id="logon"
                />
                <label htmlFor='logon' className="switch-label"/>
              </div>
            </div>
            <div className="toggle-container">
              <span className='label-title'>Email notification when a customer has completed a booking</span>
              <div className="switch-wrapper">
                <input
                onChange={(e) => {NotificationOptionHandler(e)}}
                className="toggle-switch"
                type="checkbox"
                defaultChecked={false}
                id='completeBooking'
                checked={notificationBookingComplete}
                />
                <label htmlFor='completeBooking' className="switch-label"/>
              </div>
            </div>
            <div className="toggle-container">
              <span className='label-title'>Email notification when a customer has cancelled their booking</span>
              <div className="switch-wrapper">
                <input
                onChange={(e) => {NotificationOptionHandler(e)}}
                className="toggle-switch"
                type="checkbox"
                defaultChecked={false}
                id='cancelBooking'
                checked={notificationBookingCancelled}
                />
                <label htmlFor='cancelBooking' className="switch-label"/>
              </div>
            </div>
        </main>
        );
      default:
        return null;
    }
  };
  const renderContent = () => {
    switch (activeTab.toLowerCase()) {
      case "account":
        return (
          <>
            <div className="sub-nav">
              {['Details', 'Membership', 'Payments'].map(tab => (
                <a
                  key={tab}
                  href="#"
                  className={`sub-tab ${activeSubAccountsTab === tab ? "active" : ""}`}
                  onClick={() => setActiveSubAccountsTab(tab)}
                >
                  {tab}
                </a>
              ))}
            </div>
            {renderAccountsSubPage()}
          </>
        );
      case "security":
        return (
          <main>
            <h1>Security and Privacy</h1>
            <div>
            <h3 style={{marginTop:"2rem"}}>Email Address</h3>

            <label htmlFor="">Current Email address</label>
            <input onChange={(e) => {CurrentEmailAddressHandler(e)}} type="email" id="" placeholder="current email address" />
            <label htmlFor="">New Email address</label>
            <input onChange={(e) => {NewEmailAddressHandler(e)}} type="email" id="" placeholder="new email address" />
            <button disabled={!updateEmailButton} onClick={(e) => {updateEmailAddressClick("email update")}} className={updateEmailButton ? "save-button button" : "save-disabled-button"}>Update Email</button>
            </div>

            <div style={{marginTop:"6rem"}}>
            <h3 style={{marginTop:"2rem"}}>Password</h3>
            <div class="mb-4 flex">
            </div>
            <label htmlFor="">Current Password</label>
            <div className='flex'>
            <input className="password-input" onChange={(e) => {CurrentPasswordHandler(e)}} type={currentPasswordType} id="" placeholder="current password"/>
            <Icon className="eye-icon" icon={currentPasswordIcon} size={20} onClick={(e) => {handlePasswordIconToggle("currentPassword")}}/>
            </div>
            <label htmlFor="">New Password</label>
            <input className="password-input" onChange={(e) => {NewPasswordHandler(e)}} type={newPasswordType} id="" placeholder="new password" />
            <Icon className="eye-icon" icon={newPasswordIcon} size={20} onClick={(e) => {handlePasswordIconToggle("newPassword")}}/>
            <label htmlFor="">Re-enter new password</label>
            <input className="password-input" onChange={(e) => {NewPasswordTwoHandler(e)}} type={newPasswordTwoType} id="" placeholder="re-enter new password" />
            <Icon className="eye-icon" icon={newPasswordTwoIcon} size={20} onClick={(e) => {handlePasswordIconToggle("newPasswordTwo")}}/>
            {passwordError !== '' ? <p style={{color:"red", fontSize:"0.9rem"}}>{passwordError}</p> : <></>}
            <button disabled={!updatePasswordButton} onClick={(e) => {updatePasswordClick("password update")}} className={updatePasswordButton ? "save-button button" : "save-disabled-button"}>Update Password</button>
          </div>
            {showVerficationPopup ?
          <div className="popup-overlay">
          <div className="popup-container">
            <h2>Enter Verification Code</h2>
            {verficationType === "email update" ? <p>We’ve sent a 5-character code to your new email.</p> : <p>We’ve sent a 5-character code to your email.</p>}
            <div className="code-boxes">
              {code.map((value, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  value={value}
                  onChange={(e) => handleInputChange(index, e.target.value.toUpperCase())}
                  className="code-slot"
                  autoFocus={index === 0} // Optionally auto-focus on the first input
                />
              ))}
            </div>
            {/* <button onClick={(e) => {ResendCode()}} className="cancel-btn mb-5">Resend</button> */}
            {codeInvalid ? <div><button onClick={(e) => {ResendCode()}} className="cancel-btn mb-1 button2">Resend</button> <p style={{color:"red"}}>Invalid verification code</p></div> : <></>}
            <div className="popup-actions">
              <button onClick={(e) => {VerificationCancelClick()}} className="cancel-btn">Cancel</button>
              <button disabled={!codeFull} onClick={(e) => {VerifyClick()}} className={codeFull ? "verify-btn" : "verify-disable-btn"}>Verify</button>
            </div>
          </div>
        </div>
            :
            <div></div>}
          </main>
        );
      case "customerisation":
        return (
          <>
            <div className="sub-nav">
              {['Appointments', 'Communications', 'Notifications'].map(tab => (
                <a
                  key={tab}
                  href="#"
                  className={`sub-tab ${activeSubTab === tab ? "active" : ""}`}
                  onClick={() => setActiveSubTab(tab)}
                >
                  {tab}
                </a>
              ))}
            </div>
            {renderAnalyticsSubPage()}
          </>
        );
      default:
        return null;
    }
  };
  return (
    <div>
      <ToastContainer />
      {
      isLoading ? <div className='barber-loader'></div>:
      <div style={{marginTop:0, paddingTop:0}} className="container">
        <header className='setting-header'>
          <div className="logo">Settings</div>
            <nav className="main-nav">
            {['Account', 'Security', 'Customerisation'].map(tab => (
              <a
                key={tab}
                href="#"
                className={`tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </a>
            ))}
          </nav>
        </header>
        {renderContent()}
      </div>
      }
    </div>
  );
}


export default Settings;